module.exports = __webpack_public_path__ + "img/0020.17727337.jpg";